import {Component, Input} from '@angular/core';
import {BrKurzWetterbericht} from '../../../../../../../model/vorhersagen/br-wetterbericht';

@Component({
  selector: 'app-br-kurzwetter-bericht',
  templateUrl: './br-kurzwetter-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class BrKurzwetterBerichtComponent {
  @Input() kurzWetterbericht: BrKurzWetterbericht;
}
